import * as React from "react"
import ToggleCheckbox from "@modules/ui/components/ToggleCheckbox"
import { useTogglePreviewBuilds } from "../hooks/useTogglePreviewBuilds"
import { sitePreviewSettings as sitePreviewSettingsText } from "@modules/locales/default.json"

export type EnablePreviewBuildsProps = {
  siteId: string
  previewBuildsEnabled: boolean
  disabled?: boolean
}

export function EnablePreviewBuilds({
  siteId,
  previewBuildsEnabled,
  disabled,
}: EnablePreviewBuildsProps) {
  const [togglePreviewBuilds, { errorAlert }] = useTogglePreviewBuilds(siteId)

  return (
    <React.Fragment>
      <ToggleCheckbox
        id="enable-preview-builds-checkbox"
        label={sitePreviewSettingsText.labels.enablePreviewBuilds}
        checked={!!previewBuildsEnabled}
        onChange={() => {
          togglePreviewBuilds()
        }}
        disabled={disabled}
      />
      {errorAlert}
    </React.Fragment>
  )
}
